import { Button, Paper } from "@mui/material";
import AddIcon from '@mui/icons-material/Add';

import { SiTrackPage } from "../../../components/si-track-page";
import { useState } from "react";
import { Department } from "../../../models/masters/department";
import { SiTrackGrid } from "../../../components/si-track-grid/si-track-grid";
import { columns } from "./grid-columns";
import { departmentsApiKeyStore } from "../../../api/masters/department-api-key-store";
import { UserPermissionName } from "../../../models/user-permission-name";
import { SaveHookFormDialog } from "../../../components/save-hook-form.dialog";
import { DepartmentForm } from "./department.form";
import { departmentFormSchema } from "./division-form.schema";
import { GuardedComponent } from "../../../components/guarded-component";

const styling = {
    paperStyle: { padding: '20px', borderRadius: '20px' },
};

export const DepartmentPage = () => {
    const [editItem, setEditItem] = useState<Partial<any>>();

    const handleEditDivision = (department: Department) => {
        setEditItem({ ...department, manager: { userId: 0, fullName: '' } });
    };
    const handleEditClose = () => {
        setEditItem(undefined);
    };
    const handleCreateDivision = () => {
        setEditItem({});
    };

    const formatSubmitdata = (data: any) => {
        const departmentData = {
            departmentID: data?.departmentID ?? 0,
            departmentName: data?.departmentName ?? '',
            managerID: data?.manager?.userID,
            qboDepartmentID: data?.qboDepartmentID != "N/A" ? data?.qboDepartmentID ?? null : null,
            status: 'Active'
        }
        return departmentData;
    };
    return (
        <SiTrackPage
            title="Departments"
            actionButton={
                <GuardedComponent requiredPermissions={[UserPermissionName.ADD_DEPARTMENT]}>
                    <Button
                        size="small"
                        variant="contained"
                        disableElevation={true}
                        startIcon={<AddIcon />}
                        onClick={handleCreateDivision}
                    >
                        Add Department
                    </Button>
                </GuardedComponent>
            }
        >
            <Paper elevation={0} style={styling.paperStyle}>
                <SiTrackGrid
                    fileTitle='department'
                    dataItemKey="departmentID"
                    columns={columns}
                    queryConfig={departmentsApiKeyStore.getDepartmentsWithManager()}
                    onEdit={handleEditDivision}
                    deleteMutationConfig={(deleteItem) => departmentsApiKeyStore.deleteDepartment(deleteItem.departmentID)}
                    actionPermissions={{
                        edit: UserPermissionName.EDIT_DEPARTMENT,
                        delete: UserPermissionName.DELETE_DEPARTMENT,
                        export: UserPermissionName.DOWNLOAD_GRID,
                    }}
                />
                {editItem && (
                    <SaveHookFormDialog
                        title={editItem.departmentID ? 'UPDATE DEPARTMENT' : 'CREATE DEPARTMENT'}
                        config={{
                            saveConfig: editItem.departmentID
                                ? departmentsApiKeyStore.updateDepartment()
                                : departmentsApiKeyStore.createDepartment(),
                            invalidateRoute: () => departmentsApiKeyStore.getDepartmentsWithManager(),
                        }}
                        data={editItem}
                        formatSubmitdata={formatSubmitdata}
                        yupSchema={departmentFormSchema}
                        onClose={handleEditClose}
                        size="xs"
                    >
                        <DepartmentForm />
                    </SaveHookFormDialog>
                )}
            </Paper>
        </SiTrackPage>
    );
}